import { FontAwesome5 } from "@expo/vector-icons";
import React, { useState } from "react";
import {
  Dimensions,
  View,
  StyleSheet,
  Platform,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import {
  Loading,
  StepHeader,
  BackButton,
} from "../../../components/all";

import { WebView } from "react-native-webview";
import Styles from "../../../constants/styles";



export default function Step4({ editProfile, navigation,route }) {
  const safeInsets = useSafeAreaInsets();

  const isPolicy = route.params?.gotoURL === 'policy'


  const [verifying, setVerifying] = useState(false);

  const links = {
    policy:
      "https://docs.google.com/document/d/e/2PACX-1vTHVHow1mZ2VrJ44U-cKPxdGa99J4q1p7dmNpMhudGTqARoKAq824keHJmqFSPw76c7PvLPkNGAWqcf/pub?embedded=true",
    doctorTerms:
      "https://docs.google.com/document/d/e/2PACX-1vR7TPQsU-svthrBmcWp0-TFEkVBdcJIBN7ICZoiAI3onDsMbhLprh9exxvMMn3npg/pub?embedded=true",
  };
  let iframeHTML = (url) =>
    `<iframe width="100%" height="100%" style="border:none;overflow:hidden;" src=${url}></iframe>`;





  return (
    <>
      <View
        style={{
          ...Styles.webSmallContainer,
          marginTop: 0,

        }}
      >
        <BackButton />
        <StepHeader
          label={isPolicy ? `Privacy Policy` : `Terms & Condition`}
          icon={<FontAwesome5 name="list" size={24} color="black" />}
          subtitle={`Please read the ${isPolicy ? `policy` : `terms`} carefully.`}
        />

        {Platform.OS === "web" ? (
          <iframe
            src={links.doctorTerms}
            height={"100%"}
            width={"100%"}
            style={{
              borderWidth: 0,
              height: Dimensions.get("window").height - safeInsets.top,
            }}
          />
        ) : (
          <View
            style={{
              width: "100%",
              height: Dimensions.get("window").height,
            }}
          >
            <WebView
              source={{
                html: iframeHTML(isPolicy ? links.policy : links.doctorTerms),
              }}
              originWhitelist={["*"]}
              scalesPageToFit={true}
              style={{ height: "100%", marginLeft: 48 }}
            />
            <View style={{ margin: 120 }} />
          </View>
        )}
      </View>

 
      <Loading visible={verifying && Platform.OS !== "web"} />
    </>
  );
}

const styles = StyleSheet.create({
  termsContainer: {
    paddingTop: 24,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
  },
});
